/* ============================================
   STRAPCO Theme JavaScript
   ============================================ */

(function() {
  'use strict';

  // === SCROLL REVEAL ANIMATIONS ===
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.1
  };

  const scrollObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        scrollObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.scroll-reveal').forEach(el => {
    scrollObserver.observe(el);
  });

  // === HEADER SCROLL EFFECT ===
  const header = document.getElementById('site-header');
  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    lastScroll = currentScroll;
  }, { passive: true });

  // === MOBILE MENU ===
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileToggle.classList.toggle('active');
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
  }

  // === SEARCH OVERLAY ===
  const searchToggle = document.querySelector('.search-toggle');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.getElementById('search-input');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('open');
      setTimeout(() => searchInput && searchInput.focus(), 300);
    });

    if (searchClose) {
      searchClose.addEventListener('click', () => {
        searchOverlay.classList.remove('open');
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchOverlay.classList.remove('open');
      }
    });
  }

  // === CART DRAWER ===
  const cartToggle = document.querySelector('.cart-toggle');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-drawer-overlay');
  const cartClose = document.getElementById('cart-drawer-close');

  function openCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('open');
      cartOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // === QUICK ADD TO CART ===
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.productId;

      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin"><path d="M12 2a10 10 0 100 20 10 10 0 000-20z" stroke-dasharray="30" stroke-dashoffset="10"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';

        // Update cart count
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const countEl = document.getElementById('cart-count');
            if (countEl) countEl.textContent = cart.item_count;
          });

        setTimeout(() => {
          btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
        }, 2000);
      })
      .catch(() => {
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      });
    });
  });

  // === PRODUCT PAGE: IMAGE GALLERY ===
  const gallerySlides = document.querySelectorAll('.product-gallery__slide');
  const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const index = thumb.dataset.index;

      gallerySlides.forEach(s => s.classList.remove('active'));
      galleryThumbs.forEach(t => t.classList.remove('active'));

      gallerySlides[index].classList.add('active');
      thumb.classList.add('active');
    });
  });

  // === PRODUCT PAGE: VARIANT SELECTION ===
  const optionSwatches = document.querySelectorAll('.option-swatch');
  const variantSelect = document.getElementById('product-select');

  optionSwatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      const optionName = swatch.dataset.optionName;
      const optionValue = swatch.dataset.optionValue;

      // Update active state
      swatch.parentElement.querySelectorAll('.option-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      // Update label
      const label = document.getElementById('selected-' + optionName.toLowerCase().replace(/\s+/g, '-'));
      if (label) label.textContent = optionValue;

      // Find matching variant
      if (variantSelect) {
        const selectedOptions = [];
        document.querySelectorAll('.option-swatch.active').forEach(s => {
          selectedOptions.push(s.dataset.optionValue);
        });

        const options = variantSelect.options;
        for (let i = 0; i < options.length; i++) {
          const title = options[i].textContent.trim();
          const matches = selectedOptions.every(opt => title.includes(opt));
          if (matches) {
            variantSelect.value = options[i].value;

            // Update URL
            const url = new URL(window.location);
            url.searchParams.set('variant', options[i].value);
            window.history.replaceState({}, '', url);

            // Update availability
            const addBtn = document.querySelector('.add-to-cart-btn');
            if (addBtn) {
              if (options[i].dataset.available === 'true') {
                addBtn.disabled = false;
                addBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold Out';
              }
            }
            break;
          }
        }
      }
    });
  });

  // === PRODUCT PAGE: QUANTITY SELECTOR ===
  const quantityInput = document.getElementById('quantity-input');
  const minusBtn = document.querySelector('.quantity-minus');
  const plusBtn = document.querySelector('.quantity-plus');

  if (quantityInput && minusBtn && plusBtn) {
    minusBtn.addEventListener('click', () => {
      const val = parseInt(quantityInput.value) || 1;
      if (val > 1) quantityInput.value = val - 1;
    });

    plusBtn.addEventListener('click', () => {
      const val = parseInt(quantityInput.value) || 1;
      quantityInput.value = val + 1;
    });
  }

  // === PRODUCT PAGE: ACCORDIONS ===
  document.querySelectorAll('.accordion__header').forEach(header => {
    header.addEventListener('click', () => {
      const accordion = header.parentElement;
      const isOpen = accordion.classList.contains('open');

      // Close all others
      document.querySelectorAll('.accordion').forEach(a => a.classList.remove('open'));

      // Toggle current
      if (!isOpen) accordion.classList.add('open');
    });
  });

  // === ADD TO CART FORM INTERCEPTION ===
  const addToCartForm = document.querySelector('form[action*="/cart/add"]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(addToCartForm);
      const btn = addToCartForm.querySelector('.add-to-cart-btn');
      const originalText = btn.innerHTML;

      btn.innerHTML = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(() => {
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
        btn.style.background = 'var(--accent)';

        // Update cart count
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const countEl = document.getElementById('cart-count');
            if (countEl) countEl.textContent = cart.item_count;
          });

        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.disabled = false;
          btn.style.background = '';
          openCart();
        }, 1500);
      })
      .catch(() => {
        btn.innerHTML = 'Error - Try Again';
        btn.disabled = false;
        setTimeout(() => {
          btn.innerHTML = originalText;
        }, 2000);
      });
    });
  }

  // === SMOOTH PAGE TRANSITIONS ===
  document.querySelectorAll('a[href]').forEach(link => {
    if (link.hostname === window.location.hostname && !link.getAttribute('href').startsWith('#')) {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (href && !e.ctrlKey && !e.metaKey) {
          e.preventDefault();
          document.body.style.opacity = '0';
          document.body.style.transition = 'opacity 0.2s ease';
          setTimeout(() => {
            window.location.href = href;
          }, 200);
        }
      });
    }
  });

})();
